import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { BackgroundLayer, Picture } from 'formlabs-web-components/Media';
import { Header } from 'formlabs-web-components/Type';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/600x600`;

const ProductHero = ({ attributes, children, classes, name, sku }) => (
  <BackgroundLayer backgroundColor="#f7f7f7">
    <Header level={1} displayAs={4}>
      {name}
    </Header>
    <Picture largeImage={`${cdnUrl}${attributes.image}`} width={200} />
    <p>{attributes.shortDescription}</p>
    <div>{children}</div>
  </BackgroundLayer>
);

export default DisplayComponent(ProductHero);
